import { Workspace, ProvisionType } from 'callabo-api/src';
import { TranscribingLanguageType } from 'libs/callabo-state/types/TranscribingLanguage';

export class WorkspaceModel {
  constructor(private originResponse: Workspace) {
    //
  }

  public get id(): string {
    return this.originResponse.slug;
  }

  public get name(): string {
    return this.originResponse.name;
  }

  public get createdAt(): string {
    return this.originResponse.created_at;
  }

  public get accessScope(): Workspace.default_access_scope {
    return this.originResponse.default_access_scope;
  }

  public get language(): TranscribingLanguageType {
    return this.originResponse.default_transcribe_language as TranscribingLanguageType;
  }

  public get color(): string {
    return this.originResponse.color;
  }

  public get email(): string {
    return this.originResponse.email;
  }

  public get keywords(): string[] {
    return this.originResponse.keywords ?? [];
  }

  public get recordLifecycleDays(): number {
    return this.originResponse.record_lifecycle_days;
  }

  public get use2FA(): boolean {
    return this.originResponse.use_2fa;
  }

  public get billingEmail(): string {
    return this.originResponse.billing_email;
  }

  public get ipBlockType(): Workspace.ip_block_type {
    return this.originResponse.ip_block_type;
  }

  public get saveMedia(): boolean {
    return this.originResponse.option.save_media;
  }

  public get saveDialog(): boolean {
    return this.originResponse.option.save_dialog;
  }

  public get extendedLanguages(): boolean {
    return this.originResponse.extended_languages ?? false;
  }

  public get mediaLifecycleDays(): number | null {
    return this.originResponse.option.media_lifecycle_days;
  }

  public get dialogLifecycleDays(): number | null {
    return this.originResponse.option.dialog_lifecycle_days;
  }

  public get sc(): Workspace.sc {
    return this.originResponse.sc;
  }

  public get provisionType(): ProvisionType | undefined {
    return this.originResponse.option?.provision_type;
  }

  public get maxDeviceSessionCount(): number | null {
    return this.originResponse.option?.max_device_session_count ?? null;
  }
}
